"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.processClientCallbackRequest = void 0;
const helpers_1 = require("../../helpers");
const sendEmail_1 = require("../sendEmail");
const addOrderNote_1 = require("./addOrderNote");
const getOrderById_1 = require("./getOrderById");
const processClientCallbackRequest = async (supabase, order_id, date, time, timezone, phone_number, to_address, cc_address) => {
    try {
        // get the order
        const order = await (0, getOrderById_1.getOrderById)(supabase, order_id);
        const message = `Callback requested for ${date} at ${time} (${timezone}). Phone number: ${phone_number}`;
        // create a new order note.
        const note = {
            note: message,
            order_id: order_id,
            pinned: true,
            created_by: order.client?.id,
            type: "CALLBACK_REQUEST",
        };
        await (0, addOrderNote_1.addOrderNote)(supabase, note);
        // email support with request details
        const request_support_email = {
            language_code: "en",
            template_id: helpers_1.EMAIL_SUPPORT_CALLBACK_REQUEST,
            order_id: order.id,
            data: {
                date,
                time,
                timezone,
                phone_number,
            },
        };
        if (to_address) {
            request_support_email.email_address = to_address;
        }
        if (cc_address) {
            request_support_email.cc_address = cc_address;
        }
        await (0, sendEmail_1.sendEmail)(request_support_email);
        return true;
    }
    catch (error) {
        throw new Error(error.message);
    }
};
exports.processClientCallbackRequest = processClientCallbackRequest;
